module.exports = new __parcel__URL__("80248_sq.4908e4be.jpg").toString();